__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "sdd-web-service";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.10.4", () => (Promise.all([__webpack_require__.e(352), __webpack_require__.e(550), __webpack_require__.e(914), __webpack_require__.e(431)]).then(() => (() => (__webpack_require__(9431))))));
			register("@emotion/styled", "11.10.4", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(228), __webpack_require__.e(272)]).then(() => (() => (__webpack_require__(6272))))));
			register("@mui/icons-material", "5.14.9", () => (Promise.all([__webpack_require__.e(712), __webpack_require__.e(82), __webpack_require__.e(914), __webpack_require__.e(228), __webpack_require__.e(700)]).then(() => (() => (__webpack_require__(5082))))));
			register("@mui/material", "5.14.10", () => (Promise.all([__webpack_require__.e(352), __webpack_require__.e(760), __webpack_require__.e(712), __webpack_require__.e(550), __webpack_require__.e(574), __webpack_require__.e(263), __webpack_require__.e(914), __webpack_require__.e(90), __webpack_require__.e(228), __webpack_require__.e(700)]).then(() => (() => (__webpack_require__(8263))))));
			register("@mui/styles", "5.14.10", () => (Promise.all([__webpack_require__.e(269), __webpack_require__.e(914), __webpack_require__.e(593)]).then(() => (() => (__webpack_require__(8324))))));
			register("@toorak/sdd-component-library", "1.0.0-develop.50", () => (Promise.all([__webpack_require__.e(352), __webpack_require__.e(760), __webpack_require__.e(712), __webpack_require__.e(269), __webpack_require__.e(574), __webpack_require__.e(120), __webpack_require__.e(456), __webpack_require__.e(914), __webpack_require__.e(90), __webpack_require__.e(228), __webpack_require__.e(700), __webpack_require__.e(129), __webpack_require__.e(99), __webpack_require__.e(158)]).then(() => (() => (__webpack_require__(3871))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(352), __webpack_require__.e(568), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(8568))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(352), __webpack_require__.e(41), __webpack_require__.e(914), __webpack_require__.e(90), __webpack_require__.e(63)]).then(() => (() => (__webpack_require__(8041))))));
			register("react-router-dom", "6.23.0", () => (Promise.all([__webpack_require__.e(352), __webpack_require__.e(805), __webpack_require__.e(914), __webpack_require__.e(90)]).then(() => (() => (__webpack_require__(3805))))));
			register("react", "18.3.1", () => (__webpack_require__.e(281).then(() => (() => (__webpack_require__(8281))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};